'use strict';

var useInputValidation = require('../../../../../../../../_virtual/useInputValidation.cjs');
var React = require('react');
var inputValidation = require('./inputValidation.cjs');

var hasRequiredUseInputValidation;

function requireUseInputValidation () {
	if (hasRequiredUseInputValidation) return useInputValidation.__exports;
	hasRequiredUseInputValidation = 1;

	var react = React;
	var inputValidation$1 = inputValidation.__require();

	/**
	 * A hook used to run validations against inputs.
	 */ const useInputValidation$1 = (options)=>{
	    const { isDirty, required, value, label } = options;
	    const validationError = react.useMemo(()=>{
	        if (!isDirty || !required && !inputValidation$1.isValuePresent(value)) return "";
	        if (!inputValidation$1.isValuePresent(value)) return `${label} is required`;
	        return "";
	    }, [
	        isDirty,
	        required,
	        value
	    ]);
	    return {
	        validationError
	    };
	};

	useInputValidation.__exports.useInputValidation = useInputValidation$1;
	
	return useInputValidation.__exports;
}

exports.__require = requireUseInputValidation;
//# sourceMappingURL=useInputValidation.cjs.map
